import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

export const LoginSchema = yup.object().shape({
  email: yup
    .string()
    .required(mensagemDeErroPadrao("E-mail"))
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Digite um e-mail válido"),
  senha: yup
    .string()
    .required(mensagemDeErroPadrao("Senha"))
    .min(4, "O campo senha deve ter no mínimo 4 caracteres")
    .max(100, "O campo senha deve ter no máximo 100 caracteres"),
});
